export default function QRCodeMock() {
  return (
    <div className="w-[72px] h-[72px] bg-white border-2 border-background-200 rounded-lg p-1 flex items-center justify-center shrink-0" aria-label="QR Code da FCA">
      <div className="grid grid-cols-5 gap-[2px] w-full h-full">
        {[
          [1,1,1,0,1],[1,0,0,0,1],[1,0,1,0,1],[1,0,0,0,1],[1,1,1,0,1],
          [0,0,1,0,0],[1,0,0,1,0],[0,1,0,0,1],[0,0,1,1,0],[1,1,0,0,0],
          [0,1,1,0,0],[0,0,1,1,0],[1,1,0,0,1],[0,1,0,1,0],[1,0,1,1,0],
          [1,1,1,0,1],[1,0,0,0,1],[1,0,1,0,1],[1,0,0,0,1],[1,1,1,0,1],
        ].flat().map((v, i) => (
          <div key={i} className={`rounded-[1px] ${v ? 'bg-foreground-900' : 'bg-transparent'}`}></div>
        ))}
      </div>
    </div>
  );
}